var base = require('settings/payment-method/update-payment-method-braintree');

Vue.component('spark-update-payment-method-braintree', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/payment-method/update-payment-method-braintree.js